var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel-icon-gropup1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "excel-icon-gropup2",
    transform: "translate(-92.000000, -349.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "excel-icon-gropup3",
    transform: "translate(92.000000, 349.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "excel-icon-polygon1",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5405405,25.8498498 L28.5405405,7.01501502 C28.5405405,5.53513514 27.3297297,4.32432432 25.8498498,4.32432432 L7.01501502,4.32432432 C5.53513514,4.32432432 4.32432432,5.53513514 4.32432432,7.01501502 L4.32432432,25.8498498 C4.32432432,27.3297297 5.53513514,28.5405405 7.01501502,28.5405405 L25.8498498,28.5405405 C27.3297297,28.5405405 28.5405405,27.3297297 28.5405405,25.8498498 Z",
    id: "excel-icon-path1",
    fill: "#08743B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "excel-icon-polygon2",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "19.4085206 23.007 16.1993515 18.7373576 12.8292562 23.007 8.11 23.007 13.967903 16.072023 9.23554821 10.007 14.007199 10.007 16.2227419 13.3045481 18.5814344 10.007 23.4335483 10.007 18.4757096 16.072023 24.11 23.007"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.016c4e04.svg";
export { ForwardRef as ReactComponent };